<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="content" class="app-content p-0" style="background-color: #f8f8f8">
        <div>
            <b-tabs @input="activateTab" card content-class="pt-1" ref="theTab"  @changed="tabChanged" v-model="tabIndex"  class="tabHead">
                <b-tab v-for="tab in this.$store.state.tabs" :key="tab.title" :name="tab.title" :label="tab.title"  ref="'Tab' + tab.i"  @click="onClickTab($event, tab)" active>
                    <template v-slot:title >
                        <strong>{{tab.title}}</strong> <a :class="'closeIcon'+tab.title" v-on:click="tabClose(tab)"><i class="ml-1 fa fa-times"></i></a>
                    </template>
                    <keep-alive>
                        <component :is="currentComponent" :ref="'TabContent-' + tab.i"></component>
                    </keep-alive>
                    <!--<div :ref="'TabContent-' + tab.i" @login="loginTest" ></div>-->
                </b-tab>
            </b-tabs>
        </div>
    </div>

</template>
<script>
    import Home from '../Home'
    import Case from "../case/Case";
    import User from "../case/User";
    import Email from "../case/Email";
    import Todo from "../case/Todo";

    export default {
        name: 'Tabs',
        components:{
            Home, Case,User,Email,Todo,
        },
        data() {
            return {
                tabCounter: 0,
                tabIndex:0,
                currentComponent:'',
            }
        },
        created(){
            this.openNewTab(this.$route.name);
            this.currentComponent = this.$route.name;
            //console.log(this.$route)
        },
        mounted(){
            this.openNewTab(this.$route.name);
        },
        watch:{
            $route (to){
                this.openNewTab(to.name);
                this.currentComponent = to.name;
            }
        },
        methods:{
            openNewTab:function(title){
                var titleName;
                if(typeof title=="string"){   //一级菜单name
                    titleName = title;
                }else{                        //二级菜单name
                    titleName = title.name
                }
                var isExists=false;
                for (let i = 0; i < this.$store.state.tabs.length; i++) {
                    if (this.$store.state.tabs[i].title === titleName) {
                        isExists = true;
                        this.tabIndex = i;
                    }
                }
                if(isExists===false) {
                    this.$store.commit('add_tabs', {title: titleName, i: this.tabCounter++, index: this.tabIndex});
                }
            },
            tabChanged:function(currentTabs, previousTabs ){
                /*if(currentTabs.length>previousTabs.length) {
                    var lastIndex = this.tabCounter - 1;
                    var container = this.$refs['TabContent-' + lastIndex];
                    var Comm = this.$router.getMatchedComponents()[0];
                    var comm = Vue.extend(Comm);
                    var commInstand = new comm();
                    commInstand.$mount();
                    container[0].append(commInstand.$el);
                }*/
            },
            onClickTab(event, tab){
                //this.$router.push('/'+tab.title)
            },
            tabClose:function(x){
                this.$store.commit('delete_tabs', x.i);
            },
            activateTab(newTabIndex){
                //console.log(newTabIndex);
                if(this.$store.state.tabs.length > 0){
                    if(this.$store.state.tabs[newTabIndex].title !== this.$route.name ){
                        this.$router.push('/'+this.$store.state.tabs[newTabIndex].title)
                    }
                }
            }
        }
    }
</script>
<style lang="css">
    .tab-pane .app-content{
        margin-left: 0;
    }
    .tabs .card-body{
        padding-top:0;
        padding-left:0;
        padding-right:0;
        padding-bottom: 0;
    }
    .closeIconHome{display: none!important;}
</style>
